




































import { Component, Vue } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
@Component({
  name: "submitPreview",
})
export default class SubmitPreview extends Vue {
  private get totalScore() {
    return QuestionnaireEditModule.totalScore;
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  private get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  private get submitData() {
    return QuestionnaireEditModule.submitData;
  }
}
